require('./init-global-components')

const ns = typeof window === 'undefined' ? global : window

// initialize modals to make sure they are all connected before the the app initializes
require('./registry/modals')

// bl_registry/pages/add_items
ns.AddBabylistButton = require('./shared/add-babylist-button').default

ns.AppPromo = require('./shared/app-promo').default

// bl_registry/registry/external
ns.AddOtherRegistry = require('./registry/add-other-registry').default

// bl_registry/registry/gift_tracker
ns.GiftTracker = require('./registry/gift-reservations/gift-tracker').default

// bl_registry/registry/new
ns.EUBlockedOnboarding =
  require('./registry/modules/onboarding/components/EUBlockedOnboarding/EUBlockedOnboarding').default

ns.OnboardingApp =
  require('./registry/modules/onboarding/components/OnboardingApp').default

ns.RegistryBuilder = require('./registry/modules/registry-builder').default

// bl_registry/registry/share
ns.ShareRegistry =
  require('./registry/share-page/containers/share-registry-app').default

// bl_registry/registry/show
ns.RegistryApp = require('./registry/components/registry-app').default

// bl_registry/settings/index
ns.RegistrySettings = require('registry/settings-page').default

ns.ReactRailsUJS = require('react_ujs')
